import React, { useEffect } from "react";
import "./pstyle.css";
import Header from "../components/header";
import { performVerification } from "../commonFunc/verification";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { CiLocationOn } from "react-icons/ci";
import { CiViewList } from "react-icons/ci";
import { CiWarning } from "react-icons/ci";
import { CiCircleQuestion } from "react-icons/ci";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import translations from "../locals/translation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { } from "../redux/reportSlice";
import { SyncLoader } from "react-spinners";
import { fetchDataReports, fetchDataStatements } from "../redux/reportSlice";
import { fetchQueries, fetchQueryStatements } from "../redux/querySlice";
import { fetchVendors } from "../redux/vendorSlice";
import { TfiTruck } from "react-icons/tfi";
import { BsListTask } from "react-icons/bs";
import { useLocation } from "react-router-dom";

function Dashboard() {
  const state = useLocation();
  console.log("Sate: ", state.state);
  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();
  const { reportsData, loadingReports } = useSelector((state) => state.reports);
  const { reportsStatements, loadingReportsStatements } = useSelector(
    (state) => state.reports
  );

  const { queryData, loadingQuery } = useSelector((state) => state.queries);
  const { queryStatements, loadingQueryStatements } = useSelector(
    (state) => state.queries
  );

  const { vendorData, loadingVendors } = useSelector((state) => state.vendors);

  useEffect(() => {
    dispatch(fetchDataReports());
    dispatch(fetchDataStatements());
    dispatch(fetchQueries());
    dispatch(fetchQueryStatements());
    dispatch(fetchVendors());
  }, [dispatch]);

  return (
    <>
      <Header />
      <div className="dashboard-Container">
        <div className="body-container-dashboard">
          <div className="login-heading">
            <h1> {t("Dashboard")} </h1>
            <p className="welcome-message-ctt">
              {`Hello, ` +
                `${localStorage.getItem("name")
                  ? localStorage.getItem("name")
                  : "Admin"
                }
                ` +
                ` Welcome To` +
                ` CatchThatTruck` +
                ` Admin Panel`}{" "}
            </p>
            <div className="dashboard-container-section">
              <Row xs={1} md={2} className="g-4 mt-5">
                <Col>
                  <Card
                    className="mui-card-custom"
                    onClick={() => {
                      navigate("/locations");
                    }}
                  >
                    <CiLocationOn className="react-icon" />
                    <Card.Body>
                      <Card.Title className="card-title">
                        {t("Locations")}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card
                    className="mui-card-custom"
                    onClick={() => {
                      if (!loadingVendors) {
                        navigate("/vendorslist", { state: vendorData });
                      }
                    }}
                  >
                    {loadingVendors ? (
                      <SyncLoader
                        color="#431018"
                        style={{ padding: "10px 0px" }}
                      />
                    ) : (
                      <CiViewList className="react-icon" />
                    )}
                    <Card.Body>
                      <Card.Title>{t("Vendors")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card
                    className="mui-card-custom"
                    onClick={() => {
                      if (!(loadingReports || loadingReportsStatements)) {
                        navigate("/reports", {
                          state: {
                            statements: reportsStatements,
                            mainReports: reportsData,
                          },
                        });
                      }
                    }}
                  >
                    {loadingReports || loadingReportsStatements ? (
                      <SyncLoader
                        color="#431018"
                        style={{ padding: "10px 0px" }}
                      />
                    ) : (
                      <CiWarning className="react-icon" />
                    )}
                    <Card.Body>
                      <Card.Title>{t("Reports")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card
                    className="mui-card-custom"
                    onClick={() => {
                      if (!(loadingQuery || loadingQueryStatements)) {
                        navigate("/queries", {
                          state: {
                            statements: queryStatements,
                            mainReports: queryData,
                          },
                        });
                      }
                    }}
                  >
                    {loadingQuery || loadingQueryStatements ? (
                      <SyncLoader
                        color="#431018"
                        style={{ padding: "10px 0px" }}
                      />
                    ) : (
                      <CiCircleQuestion className="react-icon" />
                    )}
                    <Card.Body>
                      <Card.Title>{t("Queries")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card
                    className="mui-card-custom"
                    onClick={() => {
                      if (true) {
                        navigate("/avatargallery");
                      }
                    }}
                  >
                    {false ? (
                      <SyncLoader
                        color="#431018"
                        style={{ padding: "10px 0px" }}
                      />
                    ) : (
                      <TfiTruck className="react-icon" />
                    )}
                    <Card.Body>
                      <Card.Title>{t("Gallery")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>

                <Col>
                  <Card
                    className="mui-card-custom"
                    onClick={() => {
                      if (true) {
                        navigate("/requests");
                      }
                    }}
                  >
                    {false ? (
                      <SyncLoader
                        color="#431018"
                        style={{ padding: "10px 0px" }}
                      />
                    ) : (
                      <BsListTask className="react-icon" />
                    )}
                    <Card.Body>
                      <Card.Title>{t("requests")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Dashboard;
